<template>
  <div class="input-button">
    <div class="input-button__button touch" @click="resetFilter">{{ language.code === 'en' ? 'Reset Filter' : 'إعادة الفرز' }}</div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isActive: false,
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),
  },

  methods: {
    resetFilter () {
      this.$store.commit('filter/SET_FILTER_PARAMETERS', {
        inputBaths: false,
        inputBeds: false,
        inputCars: false,
        inputType: null,
        inputView: false
      })
      this.$router.push(`/category/${this.$route.params.categoryId}/live/masterplan`)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.input-button {
  margin-top: 0.5em;
  position: relative;

  &__button {
    align-items: center;
    border: 0.2rem solid $white;
    border-radius: 0.7rem;
    display: flex;
    font-size: 1.2rem;
    padding: 0.3em 0.5em;
    margin-bottom: 0;
    min-width: 3rem;
    opacity: 1;
    text-align: left;
    transition: background-color 0.15s ease-in;
    width: 100%;
  }
}
</style>

